import { render, staticRenderFns } from "./planType.vue?vue&type=template&id=1f105698&scoped=true"
import script from "./planType.vue?vue&type=script&lang=js"
export * from "./planType.vue?vue&type=script&lang=js"
import style0 from "./planType.vue?vue&type=style&index=0&id=1f105698&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f105698",
  null
  
)

export default component.exports